// our-story-slider.js
// Initializes Swiper sliders for sections with the class combination
// .section_active-stories.is-our-stories ("Our Story" sliders)
// Each slider works independently with its own navigation arrows.
// Author: Fitpace Theme Dev – All code in English as per project conventions.

(function () {
  'use strict';

  /**
   * Wait until the DOM is ready and Swiper is available, then run initialisation.
   */
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper === 'undefined') {
      console.error('Swiper library not found. our-story-slider.js aborted.');
      return;
    }

    // Query all Our Story slider sections
    var ourStorySections = document.querySelectorAll('.section_active-stories.is-our-stories');

    if (!ourStorySections.length) return; // Nothing to do

    ourStorySections.forEach(function (section) {
      var swiperContainer = section.querySelector('.swiper.is-photos');
      if (!swiperContainer) return; // Skip if container missing

      // Skip if this container is already initialised by another script
      if (swiperContainer.classList.contains('swiper-initialized')) return;

      var prevButton = section.querySelector('.arrow.is-left');
      var nextButton = section.querySelector('.arrow.is-right');

      // Initialise Swiper for this section
      var storySwiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        speed: 300,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 15
          },
          1024: {
            slidesPerView: 1,
            spaceBetween: 20
          }
        },
        on: {
          init: function () {
            updateButtonState(this);
          },
          slideChange: function () {
            updateButtonState(this);
          }
        }
      });

      /**
       * Updates the visual state (opacity + pointer-events) of navigation arrows
       * according to the Swiper instance position.
       *
       * @param {Swiper} swiper – Current Swiper instance.
       */
      function updateButtonState(swiper) {
        if (prevButton) {
          if (swiper.isBeginning) {
            prevButton.style.opacity = '0.5';
            prevButton.style.pointerEvents = 'none';
          } else {
            prevButton.style.opacity = '1';
            prevButton.style.pointerEvents = 'auto';
          }
        }

        if (nextButton) {
          if (swiper.isEnd) {
            nextButton.style.opacity = '0.5';
            nextButton.style.pointerEvents = 'none';
          } else {
            nextButton.style.opacity = '1';
            nextButton.style.pointerEvents = 'auto';
          }
        }
      }
    });
  });
})();

 

